import React from 'react'
import { Box, Typography } from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { useTranslation } from 'react-i18next'

interface Props {
  title?: string
  description?: string
}

const ErrorPage: ReactFC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2rem',
        borderRadius: '10px',
        padding: '2rem',
        justifyContent: 'center',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <CancelOutlinedIcon
        sx={{
          fontSize: 100, color: '#ef5350'
        }}
      />
      <Typography
        sx={{
          fontSize: '2rem', fontWeight: 'bold'
        }}
      >
        {props.title || t('alerts.An_error_has_ocurred')}
      </Typography>
      <Typography>
        {props.description || t('alerts.Please_reload_the_page_or_try_again_later')}
      </Typography>
    </Box>
  )
}
export default ErrorPage
